import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/novelcraft/tek_img_10.webp";
import { StaticImage } from "gatsby-plugin-image";

function Gameelements() {
  return (
    <section className="game_sec_novel">
      <Container fluid>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mx-auto text-center p-0"
          >
            <h2>Game Elements</h2>
            <div className="novel_car">
              <StaticImage
                src="../../../images/case-studies/novelcraft/tek_img_10.webp"
                alt="TekRevol Novelcraft"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1920}
                height={2406}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Gameelements;
